export default "__VITE_ASSET__CvTcG2KS__"